export const getCenterTitleTag = (
  isVerified,
  hasReviews,
  isClaimed,
  hasPricing,
  locationLabel,
  title,
  isClosed,
  acceptsInsurance
) => {
  let titleTag = locationLabel
  if (isVerified) {
    if (hasReviews) {
      titleTag = `${title}: Verified Pricing, Reviews & Testimonials (${locationLabel})`
    } else {
      titleTag = `${title}: Verified Pricing, Amenities & Photos (${locationLabel})`
    }
  }

  if (isClaimed && !isVerified) {
    if (hasPricing && hasReviews) {
      titleTag = `${title}: Pricing, Reviews, Testimonials (${locationLabel})`
    }
    if (hasPricing && !hasReviews) {
      titleTag = `${title}: Pricing, Specializations & Photos (${locationLabel})`
    }
    if (!hasPricing && hasReviews) {
      titleTag = `${title}: Reviews, Testimonials & Photos (${locationLabel})`
    }
    if (!hasPricing && !hasReviews) {
      titleTag = `${title}: Treatment Options, Amenities & Photos (${locationLabel})`
    }
  }
  if (!isClaimed && !isVerified) {
    titleTag = `${title}: Treatment Options, Amenities & Photos (${locationLabel})`
  }

  if (isClosed) {
    titleTag = `${title} (Closed): Find similar centers on Recovery.com`
  }

  if (acceptsInsurance) {
    titleTag = titleTag
      .replace('Verified Pricing', 'Insurance')
      .replace('Pricing', 'Insurance')
  }

  return titleTag
}
